// extracted by mini-css-extract-plugin
export default {"hot":"index_hot_zbYHK clearfix","noList":"index_noList_Bwjsg","box_01_1":"index_box_01_1_FosOC","text":"index_text_-htUb"};